// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 337 ? "ff273499" : chunkId) + "." + {"337":"4ef9165c59a668b6","714":"8c89f0c07db3ce83","962":"44ac6c905b15f567"}[chunkId] + ".js";
};